<template>
  <div class="page-restricted page-authentication">
    <gdpr-modal :is-closeable="false"></gdpr-modal>
  </div>
</template>

<script>
import GdprModal from '../components/Modals/GdprModal.vue'

export default {
  components: {
    GdprModal
  }
}
</script>
